const SpaceIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M3 6.75C3 4.67893 4.67893 3 6.75 3H17.25C19.3211 3 21 4.67893 21 6.75V17.25C21 19.3211 19.3211 21 17.25 21H6.75C4.67893 21 3 19.3211 3 17.25V6.75ZM4.5 16.5V17.25C4.5 18.4926 5.50736 19.5 6.75 19.5H6.95943L7.95943 16.5H4.5ZM8.45943 15L9.45943 12H7.90139L5.90139 15H8.45943ZM9.54057 16.5L8.54057 19.5H15.4594L14.4594 16.5H9.54057ZM13.9594 15L12.9594 12H11.0406L10.0406 15H13.9594ZM16.0406 16.5L17.0406 19.5H17.25C18.4926 19.5 19.5 18.4926 19.5 17.25V16.5H16.0406ZM18.0986 15L16.0986 12H14.5406L15.5406 15H18.0986ZM19.5 6.75C19.5 5.50736 18.4926 4.5 17.25 4.5H6.75C5.50736 4.5 4.5 5.50736 4.5 6.75V10.5H19.5V6.75ZM4.5 14.3979L6.09861 12H4.5V14.3979ZM19.5 14.3979V12H17.9014L19.5 14.3979Z"
      fill="#747474"
    />
  </svg>
);

export default SpaceIcon;
